import { GpsDeviceWithOutStatusOutputData } from './gps-device-with-out-status-output-data.model';


export class GpsDeviceSelectByIdOutput implements IGpsDeviceSelectByIdOutput {
    status!: number;
    message!: string;
    data!: GpsDeviceWithOutStatusOutputData;

    constructor(data?: IGpsDeviceSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? GpsDeviceWithOutStatusOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GpsDeviceSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGpsDeviceSelectByIdOutput {
    status: number;
    message: string;
    data: GpsDeviceWithOutStatusOutputData;
}

